/**
 * Parallel-milestone popup mode on fresh object open (BUDOVA + ROZVADEC).
 *
 * SSOT for web / Android / iOS: while any required milestone remains incomplete,
 * always open the **picker**. Never auto-enter a single remaining milestone.
 * Spec / info opens only after explicit pick (or intentional client handoff
 * applied *after* this resolve).
 */

export const PARALLEL_MILESTONE_POPUP_MODE = {
  PICKER: 'picker',
  LINEAR: 'linear',
} as const;

export type ParallelMilestonePopupModeOnOpen =
  (typeof PARALLEL_MILESTONE_POPUP_MODE)[keyof typeof PARALLEL_MILESTONE_POPUP_MODE];

/**
 * @param openCount number of incomplete required milestones visible for the object
 * @returns `picker` when work remains, otherwise `linear` (main / post-milestone UI)
 */
export function resolveParallelMilestonePopupModeOnOpen(
  openCount: number,
): ParallelMilestonePopupModeOnOpen {
  return openCount > 0
    ? PARALLEL_MILESTONE_POPUP_MODE.PICKER
    : PARALLEL_MILESTONE_POPUP_MODE.LINEAR;
}

/** Convenience — true when fresh open must show the milestone picker. */
export function shouldOpenMilestonePickerOnObjectClick(openCount: number): boolean {
  return resolveParallelMilestonePopupModeOnOpen(openCount) === PARALLEL_MILESTONE_POPUP_MODE.PICKER;
}
